import { __assign } from '../../node_modules/tslib/tslib.es6.js';
import React__default from 'react';
import { Box } from '../layout/Box.js';
var ModalBody = React__default.forwardRef(function (props, ref) {
  return React__default.createElement(Box, __assign({
    px: ["16px", "24px"],
    py: ["12px", "16px"],
    pt: ["4px", "16px"]
  }, props, {
    ref: ref
  }));
});
export { ModalBody };